import styled from 'styled-components'
import PropTypes from 'prop-types'

const CareerProgressStyled = styled.div`
  position: relative;
  background-image: linear-gradient(179.54deg, #04001E 0.39%, #06002D 49.3%, #0A004E 98.17%, #3B1375 204.21%, #DB086F 292.6%);
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  overflow: hidden;
  padding-top: 60px;
  .ilustration-container {
    max-width: 1366px;
    margin: 0 auto;
    z-index: 2;
  }
  img {
    width: 100%;
    height: auto;
    vertical-align: bottom;
  }
  @media(min-width: 1024px) {
    padding-top: 0px;
    background-image: url(/images/projects/landing/ilustration-white-background.svg),
                      linear-gradient(179.54deg, #021323 -92.75%, #05102F 41.21%, #0D074D 102.84%);
    background-position: top center;
    background-size: cover;
    padding: 80px 0 0;
  }
  ${({ shapeWithColor }) => shapeWithColor && `
    background-image: url(/images/projects/landing/ilustration-dark-background-mobile.svg),
    linear-gradient(179.54deg, #04001E 0.39%, #06002D 49.3%, #0A004E 98.17%, #3B1375 204.21%, #DB086F 292.6%);
    @media (min-width: 1024px) {
      background-image: url(/images/projects/landing/ilustration-dark-background.svg),
      linear-gradient(179.54deg, #04001E 0.39%, #06002D 49.3%, #0A004E 98.17%, #3B1375 204.21%, #DB086F 292.6%);
    }
  `}
`

const imagePath = '/images/projects/career-ilustrations/ilustraton-career'

function CareerProgress({shapeWithColor }) {
  return (
    <CareerProgressStyled shapeWithColor={shapeWithColor}>
      <div className="ilustration-container">
        <picture>
          <source type="image/png" media="(min-width: 1366px)" width="1366" height="683" srcSet={`${imagePath}-1366.png`} />
          <source type="image/webp" media="(min-width: 1366px)" width="1366" height="683" srcSet={`${imagePath}-1366.webp`} />
          <source type="image/png" media="(min-width: 1024px)" width="1024" height="512" srcSet={`${imagePath}-1024.png`} />
          <source type="image/webp" media="(min-width: 1024px)" width="1024" height="512" srcSet={`${imagePath}-1024.webp`} />
          <source type="image/png" media="(min-width: 600px)" width="768" height="605" srcSet={`${imagePath}-768.png`} />
          <source type="image/webp" media="(min-width: 600px)" width="768" height="605" srcSet={`${imagePath}-768.webp`} />
          <source type="image/webp" srcSet={`${imagePath}-375.webp`} />
          <source type="image/png" srcSet={`${imagePath}-375.png`} />
          <img
            src={`${imagePath}-1366.png`}
            width="1366"
            height="683"
            loading="lazy"
            alt="Ilustracion que representa como crece alguien profesionalmente"
          />
        </picture>
      </div>
    </CareerProgressStyled>
  )
}

CareerProgress.defaultProps = {
  shapeWithColor: false,
}

CareerProgress.propTypes = {
  shapeWithColor: PropTypes.bool,
}

export default CareerProgress
